import type { CSSProperties } from "react";
import { theme, FONT_RUNE } from "../theme";

/**
 * Style primitives shared across the auth sheets (Login, Signup, Profile). Visually they're
 * the same bottom-sheet / side-drawer pattern as the Instructions and Story panels, just
 * sized down — auth forms don't need a whole screen.
 */

export const overlay: CSSProperties = {
  position: "fixed",
  inset: 0,
  background: "rgba(8, 5, 3, 0.7)",
  zIndex: 200,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 16,
  backdropFilter: "blur(2px)",
};

export const card: CSSProperties = {
  width: "100%",
  maxWidth: 420,
  maxHeight: "calc(100dvh - 32px)",
  display: "flex",
  flexDirection: "column",
  background: theme.bgElev,
  border: `1px solid ${theme.accent}`,
  borderRadius: 10,
  overflow: "hidden",
};

export const header: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "14px 18px 10px",
  borderBottom: `1px solid ${theme.boardEdge}`,
  background: theme.bgElev,
};

export const title: CSSProperties = {
  fontFamily: FONT_RUNE,
  fontSize: 18,
  letterSpacing: 1,
  color: theme.parchment,
};

export const closeButton: CSSProperties = {
  fontFamily: FONT_RUNE,
  fontSize: 20,
  padding: "4px 12px",
  background: theme.boardEdge,
  color: theme.parchment,
  border: `1px solid ${theme.inkSoft}`,
  borderRadius: 6,
  cursor: "pointer",
  lineHeight: 1,
};

export const body: CSSProperties = {
  padding: "16px 18px 18px",
  display: "flex",
  flexDirection: "column",
  gap: 12,
  overflowY: "auto",
  color: theme.parchment,
};

export const field: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: 6,
};

export const label: CSSProperties = {
  fontFamily: FONT_RUNE,
  fontSize: 11,
  letterSpacing: 2,
  color: theme.boardLabel,
  textTransform: "uppercase",
};

export const input: CSSProperties = {
  fontSize: 15,
  padding: "10px 12px",
  background: theme.bg,
  color: theme.parchment,
  border: `1px solid ${theme.inkSoft}`,
  borderRadius: 6,
  outline: "none",
};

export const primaryButton: CSSProperties = {
  fontFamily: FONT_RUNE,
  fontSize: 14,
  letterSpacing: 1,
  padding: "12px 16px",
  minHeight: 44,
  background: theme.accent,
  color: theme.bg,
  border: `1px solid ${theme.accent}`,
  borderRadius: 6,
  cursor: "pointer",
};

export const secondaryButton: CSSProperties = {
  fontFamily: FONT_RUNE,
  fontSize: 13,
  letterSpacing: 1,
  padding: "10px 14px",
  minHeight: 40,
  background: theme.boardEdge,
  color: theme.parchment,
  border: `1px solid ${theme.inkSoft}`,
  borderRadius: 6,
  cursor: "pointer",
};

export const linkButton: CSSProperties = {
  fontFamily: FONT_RUNE,
  fontSize: 12,
  letterSpacing: 1,
  background: "transparent",
  color: theme.accentSoft,
  border: "none",
  padding: 0,
  cursor: "pointer",
  textDecoration: "underline",
};

export const errorText: CSSProperties = {
  color: theme.captureFlash,
  fontSize: 13,
  lineHeight: 1.4,
};
